import React from "react";
import Paragraph from "../../components/common/Typography/Paragraph";

const BenefitsRow = () => {
  const benefits = [
    {
      title: "Get Local Work",
      description: "Be seen by people in your area who need your trade.",
      icon: <i className="fi fi-rs-briefcase text-2xl"></i>
    },
    {
      title: "Fair Pay, On Your Terms",
      description: "Agree price directly with the customer — no undercutting.",
      icon: <i className="fi fi-rs-dollar text-2xl"></i>
    },
    {
      title: "Less Chasing",
      description: "Work comes to you, so you spend more time on the tools.",
      icon: <i className="fi fi-rs-clock text-2xl"></i>
    },
    {
      title: "Grow Your Reputation",
      description: "Build trust with reviews and turn jobs into repeat work.",
      icon: <i className="fi fi-rs-star text-2xl"></i>
    }
  ];

  return (
    <section className="w-full">
      <div className="tp-container-small mx-auto my-48 mb-60">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-16 gap-y-16">
          {benefits.map((benefit, index) => (
            <div key={index} className="flex flex-col items-start">
              <div className="w-8 h-8 mb-2 flex items-center justify-start rounded-xl">
                {benefit.icon}
              </div>
              <div>
                <Paragraph variant="MainParagraph" className="mb-1">
                  <span className="font-bold">{benefit.title}.</span> {benefit.description}
                </Paragraph>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsRow;
